import useActionState from "./useActionState";
import {
    activarFamilia,
    bajarFamilia,
    desactivarFamilia,
    eliminarFamilia,
    grabarFamilia,
    subirFamilia,
    refreshFamiliasCache,
} from "../../../services/backend/catalogService";

const useFamiliaCrud = ({ tipo, selectedFamiliaData, setSelectedFamiliaData, reload, onError }) => {
    const { loading: actionLoading, run } = useActionState({
        onSuccess: async () => {
            await refreshFamiliasCache();
            await reload();
        },
        onError,
    });

    const handleAgregarFamilia = async (data) => {
        await run(async () => {
            const padre = data.padreId || 0;
            await grabarFamilia({ id: 0, nombre: data.nombre, orden: data.orden || 0, padre, tipo });
        });
    };

    const handleEditarFamilia = async (data) => {
        await run(async () => {
            const padre = selectedFamiliaData?.raw?.padre || selectedFamiliaData?.id || 0;
            await grabarFamilia({ id: data.id, nombre: data.nombre, padre, tipo });
        });
    };

    const handleToggleActivo = async (rowData, nuevoEstado) => {
        const id = rowData?.id;
        if (!id) return;
        await run(async () => {
            if (nuevoEstado) {
                await activarFamilia(id, tipo);
            } else {
                await desactivarFamilia(id, tipo);
            }
        });
    };

    const handleSubirPrioridad = async () => {
        if (!selectedFamiliaData) return;
        await run(async () => {
            await subirFamilia(selectedFamiliaData.id, tipo);
        });
    };

    const handleBajarPrioridad = async () => {
        if (!selectedFamiliaData) return;
        await run(async () => {
            await bajarFamilia(selectedFamiliaData.id, tipo);
        });
    };

    const handleEliminarFamilia = async (data) => {
        const id = data?.id;
        if (!id) return;
        await run(async () => {
            const result = await eliminarFamilia(id, tipo);
            if (result?.mensaje) {
                const err = new Error(result.mensaje);
                err.severity = "warn";
                throw err;
            }
            setSelectedFamiliaData(null);
        });
    };

    return {
        actionLoading,
        handleAgregarFamilia,
        handleEditarFamilia,
        handleToggleActivo,
        handleSubirPrioridad,
        handleBajarPrioridad,
        handleEliminarFamilia,
    };
};

export default useFamiliaCrud;